<template>
  <el-config-provider :locale="elementLocale">
    <router-view />
    <ReDialog />
  </el-config-provider>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue';
import { ElConfigProvider } from 'element-plus';
import { ReDialog } from '@/components/ReDialog';
import { useTranslation } from 'i18next-vue';
import en from 'element-plus/es/locale/lang/en';
import zh from 'element-plus/es/locale/lang/zh-cn';

export default defineComponent({
  name: 'app',
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
    ReDialog,
  },
  setup() {
    const { i18next } = useTranslation();

    // 计算 Element Plus 语言包
    const elementLocale = computed(() =>
      i18next.language?.startsWith('zh') ? zh : en,
    );
    return { elementLocale };
  },
});
</script>

<style lang="scss">
.el-space--vertical > .el-space__item {
  width: 100%;
}
</style>
